import { useRef } from "react";
import ShowItemContent from "./ShowItemContent"
import { isVisuallyEmptyTextEditor, removeTrailingEmptyLinesTextEditor } from "../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/utils/utils";

const FormattingTextField = ({ item, isGroupNote }) => {
  let noValExistText = <p className="text ar-light-color">No data recorded</p>;
  let formattingNoteText = removeTrailingEmptyLinesTextEditor(item.content || '');
  let divContent =
    <>
      {isVisuallyEmptyTextEditor(item.content) ?
        noValExistText :
        <div className="ql-editor p-0 overflow-visible ql-view-content h-auto lh-normal"><p className="text" dangerouslySetInnerHTML={{ __html: formattingNoteText }}></p></div>}
    </>
  return (<>
    {item.content?.trim() ?
      <>
        {/* <div className="">
        <p className='text' style={{ whiteSpace: "pre-line" }}>{ShowItemContent(item, isGroupNote, divContent)}</p>
      </div>  */}
        {ShowItemContent(item, isGroupNote, divContent)}
      </> : <></>}
  </>
  )
}

export default FormattingTextField